<template>
  <div>
<div >
<section>
<center>

   <div style="padding:177.78% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/356573793" style="position:absolute;top:0;left:0;height:100%;width:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
<p><a href="https://vimeo.com/356573793">LiveTrackz Basics</a> from <a href="https://vimeo.com/livetrackz">LiveTrackz</a> on <a href="https://vimeo.com">Vimeo</a>.</p>

</center>
</section>
</div>
     <!-- load the style -->
    <color/>
    <!-- load the js to dismiss loader -->
    <js/>
  </div>
</template>

<script>
export default {
  name: 'how_to_video'
}
</script>



// WEBPACK FOOTER //
// src/pages/how_to_video.vue